// extracted by mini-css-extract-plugin
export default {"future":"LessonBulb_future__MQQTY","past":"LessonBulb_past__-mjcu LessonBulb_future__MQQTY","small":"LessonBulb_small__qeEvK"};